module.exports = __webpack_public_path__ + "img/hr-H-B-246-unload-connect.ce049d0d.png";